export enum IdentityQuestion {
  IdentityIntro = "IDENTITY_INTRO",
  Identity = "IDENTITY_WIDGET",
  NameExtension = "IDENTITY_NAME_EXTENSION",
  IdentityCompliance = "IDENTITY_COMPLIANCE",
  Poa = "IDENTITY_PROOF_OF_ADDRESS",
  PoaOpenbanking = "IDENTITY_PROOF_OF_ADDRESS_OPENBANKING",
  PoaAddressMismatch = "IDENTITY_POA_ADDRESS_MISMATCH",
}

export const IDENTITY_FIELD_TO_PATH: Record<IdentityQuestion, string> = {
  [IdentityQuestion.IdentityIntro]: "intro",
  [IdentityQuestion.Identity]: "id",
  [IdentityQuestion.NameExtension]: "name-extension",
  [IdentityQuestion.IdentityCompliance]: "check",
  [IdentityQuestion.Poa]: "poa",
  [IdentityQuestion.PoaOpenbanking]: "poa-openbanking",
  [IdentityQuestion.PoaAddressMismatch]: "poa-address-mismatch",
};

export interface NameExtensionFormValues {
  firstName?: string;
  middleNames?: string;
  lastName?: string;
}
